import Modal from '@material-ui/core/Modal';
import makeStyles from '@material-ui/core/styles/makeStyles';
import useTheme from '@material-ui/core/styles/useTheme';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import React, { lazy } from 'react';
import { ModalHeader } from './style';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Icon = lazy(() => import(`../../Icon/${layout}`));

const useStyles = makeStyles((theme) => ({
  modal: (props) => ({
    backgroundColor: props.isresets ? theme.colors.BLACK : '',
  }),
  paper: (props) => ({
    position: 'absolute',
    width: props.isUserProfile
      ? ''
      : props.isExportPopup
      ? 150
      : props.withCloseIcon && !props.propWidth && !props.companyData && !props.contractHistory && !props.inspectionPopup
      ? props.heightSet
      : props.propWidth
      ? props.propWidth
      : props.isLoader
      ? '100%'
      : props.contractHistory
      ? '690px'
      : props.registrationPopup
      ? props.registrationPopup
      : props.timeZone
      ? '563px'
      : props.companyData
      ? props.companyWidth
      : props.inspectionPopup
      ? '350px'
      : props.heightSet1,
    backgroundColor:
      props.background && !props.backgroundModal
        ? props.background
        : props.isUserProfile
        ? theme.colors.MODAL_BACKGROUND
        : props.backgroundModal
        ? '#1b1b1b'
        : props.registrationcolorPopup
        ? '#000'
        : theme.colors.BACKGROUND,
    border: props.isExportPopup || props.isLoader ? 'none' : `2px solid ${theme.colors.MODAL_BORDER}`,
    boxShadow: theme.shadows[5],
    borderRadius: props.companyData ? '6px' : '',
    padding: props.isUserProfile ? '' : props.timeZone ? '25px' : '17px',
    color: theme.colors.MODAL_LINK,
    justifyContent: 'center',
    alignItems: props.background ? 'space-around' : props.alignItemsLeft ? 'left' : 'center',
    display: props.exportDisplay || 'flex',
    flexDirection: 'column',
    height: props.isExportPopup ? 100 : props.isLoader ? '100%' : '',
    opacity: props.isLoader ? '0.8' : '',
  }),
}));

const SimpleModal = ({
  open,
  setOpen,
  ParentWrapper,
  ModalWrapper,
  ModalWrapper2,
  exportDisplay,
  isExportPopup,
  isUserProfile,
  optionListPopup,
  top: propTop,
  right: propRight,
  isresets,
  width: propWidth,
  withCloseIcon,
  withCloseIconHeader,
  isLoader,
  contractHistory,
  background,
  alignItemsLeft,
  data,
  onCloseModal,
  removeTopSpace,
  deletePopup,
  isSuccess,
  disableEscapeKeyDown,
  disableBackdropClick,
  registrationPopup,
  isdepartmentModal,
  onClose,
  companyData,
  timeZone,
  backgroundModal,
  registrationcolorPopup,
  inspectionPopup,
  onCloseFn,
}) => {
  const theme = useTheme();

  function getModalStyle() {
    if (!isUserProfile && !isExportPopup) {
      const top = 50;
      const left = 50;

      return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
        outline: 'none',
      };
    } else if (isUserProfile && !isdepartmentModal) {
      const top = optionListPopup ? propTop : 40;
      const right = propRight || 1;

      return {
        top: `${top}px`,
        right: `${right}%`,
        outline: 'none',
        background: optionListPopup ? theme.colors.PRIMARY_MAIN : theme.colors.MODAL_BACKGROUND,
      };
    } else if (isExportPopup) {
      const top = 119;
      const left = 80.5;

      return {
        top: `${top}px`,
        left: `${left}%`,
        outline: 'none',
      };
    } else if (isdepartmentModal && isUserProfile) {
      const top = 158;
      const right = 3;

      return {
        top: `${top}px`,
        right: `${right}%`,
        outline: 'none',
        backgroundColor: '#1b1b1b',
      };
    }
  }
  const sm = useMediaQuery(theme.breakpoints.between('xs', 'sm'));
  const md = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  let heightSet = sm ? 300 : md ? 342 : 400;
  let heightSet1 = sm ? 300 : md ? 342 : 516;
  let companyWidth = sm ? 300 : md ? 342 : 700;

  const classes = useStyles({
    isUserProfile,
    isExportPopup,
    withCloseIcon,
    propWidth,
    companyData,
    contractHistory,
    inspectionPopup,
    heightSet,
    heightSet1,
    background,
    backgroundModal,
    registrationcolorPopup,
    registrationPopup,
    timeZone,
    companyWidth,
    isLoader,
    alignItemsLeft,
    exportDisplay,
    isresets,
  });

  const [modalStyle] = React.useState(getModalStyle);

  const handleClose = () => {
    onCloseFn && onCloseFn();
    setOpen(false);
    return onCloseModal ? onCloseModal('closed') : '';
  };
  return (
    <ParentWrapper>
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={onClose || handleClose}
        className={classes.modal}
        disableEscapeKeyDown={disableEscapeKeyDown || false}
        disableBackdropClick={disableBackdropClick || false}
      >
        {!isUserProfile && !deletePopup && !removeTopSpace ? (
          <ModalWrapper2 style={modalStyle} className={classes.paper}>
            {withCloseIcon ? (
              <div id="closeBtn">
                <Icon onClick={() => handleClose()} src={mediaUrls?.closeIcon}></Icon>
              </div>
            ) : (
              ''
            )}
            {withCloseIconHeader ? (
              <ModalHeader style={{ width: '100%', marginTop: '1rem' }}>
                <h2
                  id="modal-title"
                  style={
                    {
                      ...data?.headerStyle,
                      margin: '0px',
                    } || { margin: '0px' }
                  }
                >
                  {data.header}
                </h2>
                <div id="closeBtn" className="icon_position">
                  <Icon onClick={() => handleClose()} src={mediaUrls?.closeIcon}></Icon>
                </div>
              </ModalHeader>
            ) : (
              ''
            )}
            {withCloseIcon || withCloseIconHeader || isSuccess || timeZone ? '' : <h2 id="modal-title">{data.header}</h2>}
            {typeof data.content == 'string' ? <p id="modal-description">{data.content}</p> : <data.content />}
            {withCloseIcon || isSuccess || timeZone ? '' : <p id="modal-footer">{data.id}</p>}
          </ModalWrapper2>
        ) : removeTopSpace ? (
          <ModalWrapper style={modalStyle} className={classes.paper} width={propWidth}>
            <div
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
              }}
              id="closeBtn"
            >
              <Icon onClick={() => handleClose()} src={mediaUrls?.closeIcon}></Icon>
            </div>
            <data.content />
          </ModalWrapper>
        ) : (
          <ModalWrapper style={modalStyle} className={classes.paper} width={propWidth}>
            {withCloseIcon ? (
              <div id="closeBtn">
                <Icon onClick={() => handleClose()} src={mediaUrls?.closeIcon}></Icon>
              </div>
            ) : (
              ''
            )}
            {typeof data.content == 'string' ? <p id="modal-description">{data.content}</p> : <data.content />}
          </ModalWrapper>
        )}
      </Modal>
    </ParentWrapper>
  );
};

export default SimpleModal;
